(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["1-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const mainContent = document.getElementById('MainContent');
    const header = document.querySelector('.custom-header');
    const templateName = header.dataset.templateName;
    const sticky = header.dataset.sticky;
    const rect = header.getBoundingClientRect();

    window.addEventListener('scroll', () => {
      if (templateName === 'index' && sticky === 'true' && window.scrollY > 0) {
        header.parentNode.classList.add('sticky');
      } else {
        header.parentNode.classList.remove('sticky');
      }
    });
  });

  const mainList = document.querySelectorAll('.header__nav li');
  const deviceSize = window.innerWidth;
  let eventType = 'click';
  if (deviceSize < 750) {
    eventType = 'click';
  } else {
    eventType = 'mouseenter';
  }
  mainList.forEach((el) => {
    el.addEventListener(eventType, (event) => {
      const children = el.querySelectorAll('.child');
      if (children.length > 0) {
        event.preventDefault();
        children.forEach((child) => {
          el.classList.toggle('active');
        });
      }

      const childLinks = el.querySelectorAll('.child li');
      childLinks.forEach((childLink) => {
        childLink.addEventListener('click', (event) => {
          event.stopPropagation();
        });
      });
    });

    window.addEventListener('mouseout', (event) => {
      mainList.forEach((el) => {
        if (!el.contains(event.target)) {
          el.classList.remove('active');
        }
      });
    });
  });

  const navOverlay = document.querySelector('.nav-overlay');
  const burger = document.querySelector('.header__burger');
  const burgerClose = document.querySelector('.burger-close');

  burger.addEventListener('click', () => {
    navOverlay.classList.add('active');
    if (navOverlay.classList.contains('active')) {
      document.body.style.overflow = 'hidden';
    }
  });

  burgerClose.addEventListener('click', () => {
    navOverlay.classList.remove('active');
    document.body.style.overflow = 'visible';
  });

  const headerSearch = document.querySelector('.header__search');
const searchIcons = document.querySelectorAll('.header__search-icon');
const searchIconClose = document.querySelector('.search-bar__close-icon');
const predictiveSearch = document.querySelector('.predictive-search__input');

// Add event listeners to all search icons
searchIcons.forEach((searchIcon) => {
  searchIcon.addEventListener('click', () => {
    headerSearch.classList.add('active');
    predictiveSearch.focus();
  });
});

// Add event listener to the close icon
if (searchIconClose) {
  searchIconClose.addEventListener('click', () => {
    headerSearch.classList.remove('active');
  });
}


  const heroBanner = document.querySelector('.image-with-text__image-wrapper');
  const header = document.querySelector('.custom-header');
  const templateName = header.dataset.templateName;

  // if (templateName === 'index') {
  //   window.addEventListener('mousemove', (e) => {
  //     const x = e.clientX / window.innerWidth;
  //     const y = e.clientY / window.innerHeight;

  //     const movementX = (0.5 - x) * 5;
  //     const movementY = (0.5 - y) * 5;

  //     heroBanner.style.transform = `translate(${movementX}px, ${movementY}px)`;
  //   });
  // }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["1-product-recommendation"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const sectionName = document.querySelector('.product-recommendations');
    const sectionContent = document.querySelector('.product-recommendations__content');

    const productId = sectionName.getAttribute('data-product-id');

      fetch(`${window.Shopify.routes.root}recommendations/products.json?product_id=${productId}&limit=4`)
      .then((response) => response.json())
      .then(({ products }) => {
        sectionContent.innerHTML = '';

        if (products && products.length > 0) {
          products.forEach((product) => {
            const formattedPrice = Shopify.formatMoney(product.price);

            const html = `
            <div class="product-recommendations__card">
              <a href="${product.url}" class="product-recommendations__link">
                <img src="${product.images[0]}" alt="${product.title}" />
                <p class="product-recommendations__product-title">${product.title}</p>
                <div><strong>${formattedPrice}</strong></div>
              </a>
            </div>
            `;
            sectionContent.innerHTML += html;
          });
        }
      })
      .catch((error) => {
        console.error('Error fetching product recommendations:', error);
      });
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["1-slider-with-cta"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const sliderWithCta = document.querySelector('.slider-with-cta');
    const autoplayValue = sliderWithCta.getAttribute('data-autoplay');
    const autoplay = autoplayValue === 'true';
    const swiper = new Swiper('.slider-with-cta__swiper', {
      loop: true,
      autoplay: autoplay,
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      slidesPerView: 1,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["8-hero-banner"] && !Shopify.designMode) return;
  try {
    
  const scrollToBottom = document.querySelector(".hero-banner-layout-8__chevron-down");
  const bannerSection = document.querySelector(".hero-banner-layout-8");
  const announcementBar = document.querySelector(".announcement-bar");

  // if (announcementBar) {
  //   const announcementBarHeight = announcementBar.offsetHeight;
  //   const adjustedHeight = `calc(100vh - ${announcementBarHeight}px)`;
  //   bannerSection.style.height = adjustedHeight;
  // } else {
  //   const adjustedHeight = `100vh`;
  //   bannerSection.style.height = adjustedHeight;
  // }

  scrollToBottom.addEventListener("click", () => {
  const nextSection = bannerSection.parentNode.nextElementSibling;
  if (nextSection) {
    nextSection.scrollIntoView({ behavior: "smooth" });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
